// @ts-nocheck
// TODO: tighten types after migration
import React, { useEffect, useState } from "react";
import "./ImageGalleryDots.css"; // For styles

const DashedLines = ({ totalDashes, currentDashIndex }) => {
  const [highlightedIndex, setHighlightedIndex] = useState(0);

  useEffect(() => {
    // Update the highlighted dash based on the provided currentDashIndex prop
    if (currentDashIndex >= 0 && currentDashIndex < totalDashes) {
      setHighlightedIndex(currentDashIndex);
    }
  }, [currentDashIndex, totalDashes]);

  const renderDashedLines = () => {
    const lines = [];
    for (let i = 0; i < totalDashes; i++) {
      lines.push(
        <span
          key={i}
          className={`dashed-line ${i === highlightedIndex ? "highlighted" : ""} flex-grow h-[3px] mx-0.5 bg-[#ddd] rounded transition-colors duration-300 ${i === highlightedIndex ? 'bg-[#47b5ff]' : ''}`}
        ></span>
      );
    }
    return lines;
  };

  return <div className="dashed-lines-container flex justify-between w-full">{renderDashedLines()}</div>;
};

export default DashedLines;

